import Box, { type BoxProps } from '@mui/material/Box';

export function Center(props: BoxProps) {
  return <Box display="flex" alignItems="center" justifyContent="center" {...props} />;
}
